import './Footer.css'

const Footer = () => {

  return (
    <footer>Proyecto realizado por Lorena Cortés y Carlos Liao.🚀</footer>
  )
}
export default Footer